import React from "react";

export const Approch = () => {
  return (
    <div className="approch container">
      <div className="row align-items-center pb-5">
        <div className="col-lg-6" data-aos="fade-up" data-aos-delay="300">
          <button className="btn-gradient mb-3">Join the Stabolution</button>
          <div className="d-flex align-items-center">
            <h2 className="text-gradient">
              Beyond digital dollars
            </h2>
          </div>
          <p>
            USB is more than just a tokenized dollar. Built to be more decentralized and independent of banks,
            USB combines stability with yield generation, redefining the Stablecoin Standard.
          </p>
        </div>
        <div className="col-lg-6 text-center" data-aos="fade-up" data-aos-delay="300">
          <div className="image-section">
            <img src="./images/join.png" alt="" />
          </div>
        </div>
      </div>
      {/* <div className="row mt-5">
          <div className="col-lg-8 mb-4">
            <div className="cards " data-aos="fade-right" data-aos-delay="300">
              <div className="row align-items-end">
                <div className="col-lg-6 p-5">
                  <h2>A Smarter Financial Model</h2>
                  <p>
                    USB preserves its USD value through advanced delta-neutral
                    hedging, ensuring unmatched stability and reliability.
                  </p>
                </div>
                <div className="col-lg-6">
                  <img className="w-100" src="/images/financialmodel.png" alt="financialmodel" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="cards  p-5" data-aos="fade-left" data-aos-delay="300">
              <img src="/images/next-grn.png" alt="next" />
              <h2>Next-Gen Stablecoin</h2>
              <p>
                Designed for speed, security, and efficiency—USB enables fast,
                low-cost, and borderless transactions.
              </p>
            </div>
          </div>

          <div className="col-lg-4 mb-4">
            <div className="cards p-5" data-aos="fade-right" data-aos-delay="300">
              <img src="/images/bankless.png" alt="next" />
              <h2>Truly Bankless</h2>
              <p>
                No banks, no restrictions—USB safeguards your assets from freezes
                and crackdowns, giving you full control.
              </p>
            </div>
          </div>
          <div className="col-lg-8 mb-4" data-aos="fade-left" data-aos-delay="300">
            <div className="cards">
              <div className="row align-items-end">
                <div className="col-lg-6 p-5">
                  <h2>Built on Decentralization</h2>
                  <p>
                    Decentralization is at the heart of USB, ensuring
                    transparency, security, and true financial autonomy.
                  </p>
                </div>
                <div className="col-lg-6">
                  <img className="w-100" src="/images/decentrlization.png" alt="financialmodel" />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      <div className="row align-items-center pb-5">
      <div className="col-lg-6" data-aos="fade-up" data-aos-delay="400">
            <div className="video-wrapper">
            <video autoPlay loop muted playsInline className="video">
              <source src="/images/circlestabolut.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            </div>
          </div>
        <div className="col-lg-6" data-aos="fade-up" data-aos-delay="300">
          <div className="d-flex align-items-center">
            <h2 className="text-gradient">
              Overcollateralized stability
            </h2>
          </div>
          <p>
          <img className="" alt="" src="/images/usb-logo-black.png" style={{verticalAlign: "middle", paddingRight: "0.5rem", height: "25px", marginBottom: "0.35rem" }} /> 
          is backed by a basket of cryptoassets (mainly bitcoin and ether) and it’s pegged to the USD using delta-neutral strategies.
          </p>
        </div>

      </div>
    </div>
  );
};
